module.exports = __webpack_public_path__ + "img/mobileapp-website.673dc934.jpg";